import { Dispatch } from "redux";
import { fetchUserDetails, fetchUserData, fetchAllUsers, fetchCloudfront, fetchOpenCollections, fetchUserReadConfirm } from "../..";
import { ApiConfig } from "../../config";
import { fetchCustomInputMappings } from "../../redux/data/globalData/customInputMapping/customInputMappingActions";
import { fetchAllLevels } from '../../redux/data/globalData/levels/fetchAllLevels'
import { fetchAllOrgLabel } from '../../redux/data/globalData/labels/fetchAllLabels'

export const loadUserData = (config: ApiConfig) => (dispatch: Dispatch) => {
    //The reason for dispatch<any> https://github.com/angular-redux/store/issues/264
    dispatch<any>(fetchUserDetails(config))
    dispatch<any>(fetchUserData(config))
    dispatch<any>(fetchUserReadConfirm(config)())
    dispatch<any>(fetchAllUsers(config))
    dispatch<any>(fetchCloudfront(config))
    dispatch<any>(fetchOpenCollections(config))
    dispatch<any>(fetchCustomInputMappings(config))
    dispatch<any>(fetchAllLevels(config))
    dispatch<any>(fetchAllOrgLabel(config))
}